module.exports = __webpack_public_path__ + "static/media/galerija_2023 (2).9d90adba.png";